import { createFileRoute } from "@tanstack/react-router"
import { AppointmentsPage } from "@/features/operations/appointments-page"
import { validateAppointmentsSearch } from "@/features/operations/appointments-search"
export const Route = createFileRoute("/_authenticated/appointments")({
    validateSearch: validateAppointmentsSearch,
    component: AppointmentsPage,
})
